<template>
  <svg :class="svgClass"  >
    <linearGradient id="linear" x1="0%" y1="10%" x2="0%" y2="100%">
      <!-- 设置渐变色,使用stop标签 -->
      <stop offset="20%" stop-color="rgba(255, 240, 158, 1)"></stop>
      <stop offset="100%" stop-color="rgba(17, 197, 140, 1)"></stop>
    </linearGradient>

    <title v-if="title">{{ title }}</title>
    <use :xlink:href="icon" :fill="active ? 'url(#linear)' : 'currentColor'" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',

  props: {
    title: {
      type: String,
      default: ''
    },

    iconName: {
      type: String,
      required: true
    },

    iconClass: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    
  },

  computed: {
    icon() {
      return `#icon-${this.iconName}`
    },

    svgClass() {
      if (this.iconClass) {
        return 'svg-icon ' + this.iconClass
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  margin-right: 5px;
  vertical-align: -0.15em;
  overflow: hidden;
}
</style>
